import React from 'react';

import { Select } from 'antd';

import { ClockCircleOutlined } from '@ant-design/icons';

const { Option } = Select;

interface CustomTimePickerProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  error?: string;
}

const CustomTimePicker: React.FC<CustomTimePickerProps> = ({
  value,
  onChange,
  placeholder = 'Select time',
  style,
  error,
}) => {
  const generateTimeOptions = () => {
    const times: string[] = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const formattedTime = `${String(hour).padStart(2, '0')}:${String(
          minute,
        ).padStart(2, '0')}`;
        times.push(formattedTime);
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();

  const handleChange = (time: string) => {
    if (onChange) {
      onChange(time);
    }
  };
  return (
    <Select
      value={value || undefined}
      onChange={handleChange}
      placeholder={placeholder}
      style={style}
      suffixIcon={<ClockCircleOutlined />}
      status={error ? 'error' : ''}
    >
      {timeOptions.map((time) => (
        <Option key={time} value={time}>
          {time}
        </Option>
      ))}
    </Select>
  );
};

export default CustomTimePicker;
